import { getQueryParams, makeRequest } from '../utils';
import authFetch from '../fetch';

export const getDQFFileGrid = (params) => makeRequest(authFetch.get(`/api/DQFFiles/${getQueryParams(params)}`));

export const putDQFFile = (data) => makeRequest(authFetch.put('/api/DQFFiles', data));

export const deleteDQFFile = (id) => makeRequest(authFetch.delete(`/api/DQFFiles/${id}`));

export const changeDqfFileOrder = (data) => makeRequest(authFetch.patch('api/DQFFiles/ChangeOrder', data));

// Audit
export const getDQFFilesAudit = (id, params) => makeRequest(
  authFetch.get(`/api/DQFFiles/${id}/Audits${getQueryParams(params)}`),
);

export const getDQFFilesProperties = (id, params) => makeRequest(
  authFetch.get(`/api/DQFFiles/${id}/Audits/Properties${getQueryParams(params)}`),
);

export const getDQFFilesAuditUsers = (id, params) => makeRequest(
  authFetch.get(`/api/DQFFiles/${id}/Audits/Users${getQueryParams(params)}`),
);
